import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedMessage, FormattedDate, FormattedNumber, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import messages from './messages'

const Row = ({ id, title, contact, created }) => {
  const { formatMessage } = useIntl()
  const uriRef = useRef(null)
  const [copied, setCopied] = useState(false)

  const onCopyToClipBoard = () => {
    navigator.clipboard.writeText(`https://voice-selector.com/${id}`)
    setCopied(true)
  }

  return (
    <tr className="cursor-pointer border-b border-gray-100" tabIndex={0}>
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedDate value={new Date(created)} />
      </td>

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <span>{ contact }</span>
      </td>

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <a className="text-primary-darker hover:text-primary" target="_blank" href={`https://voice-selector.com/${id}`}>{`https://voice-selector.com/${id}`}</a>
      </td>

      <td className="w-20 px-1 xl:px-4 py-2 xl:py-3">
        <button
          className="z-0 w-8 h-8 flex justify-center items-center rounded-full hover:bg-gray-100 text-gray-400 hover:text-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-darker z-0"
          id="user-menu"
          aria-haspopup="true"
          title={formatMessage(messages.copy)}
          onClick={onCopyToClipBoard}
        >
          <span className="sr-only"><FormattedMessage{...messages.copy}/></span>
          <Icon icon={copied ? 'check' : 'share'} />
        </button>
      </td>
    </tr>
  )
}

export default Row
